import ApiService from "@/core/services/api.service";

const _ = require('lodash');
export const SALE_LEVEL_UP_TRAINING = "sale-level-up-training";
export const SALE_LEVEL_UP_PROGRAMS = "sale-level-up-programs";
export const SALE_LEVEL_UP_COURSES = "sale-level-up-courses";
export const ATTEND_SALE = "attend-sale";
export const GET_COURSES = "get_courses";
export const GET_OPENING_CLASS = 'class-open-status'
export const GET_OPENING_CLASS_STUDENTS = 'class-open-status/all-student-by-class'
export const GET_OPERATING_AREAS = 'operating-areas'
const state = {};
const getters = {};
const actions = {
    // Get provinces
    [GET_COURSES](context, payload) {
        return new Promise(resolve => {
            ApiService.query('courses', payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
            });
        })
    },

    [SALE_LEVEL_UP_TRAINING](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${SALE_LEVEL_UP_TRAINING}`, payload)
            .then(({data}) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },
    [SALE_LEVEL_UP_PROGRAMS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${SALE_LEVEL_UP_PROGRAMS}`, payload)
            .then(({data}) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },
    [SALE_LEVEL_UP_COURSES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${SALE_LEVEL_UP_COURSES}`, payload)
            .then(({data}) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },
    [ATTEND_SALE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${ATTEND_SALE}`, payload)
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_OPENING_CLASS](context, payload) {
        return new Promise(resolve => {
            ApiService.query(GET_OPENING_CLASS, payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
            });
        })
    },
    [GET_OPENING_CLASS_STUDENTS](context, classId) {
        return ApiService.get(GET_OPENING_CLASS_STUDENTS, classId).then(({data}) => data);
    },
    [GET_OPERATING_AREAS](context, payload) {
        return new Promise(resolve => {
            ApiService.query(GET_OPERATING_AREAS, payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
            });
        })
    },
};
const mutations = {};
export default {
    state,
    actions,
    mutations,
    getters
};
